<script lang="ts">
  import Layout from "$app/Layouts/Plan.svelte"
  import { formatDate } from "$app/utils"
  import { ChevronsRight } from "lucide-svelte"
  import { appStore } from "$app/store.svelte"

  let props = $props()
  let plan: PlanType = props.plan
  let current_user: UserType = props.current_user
  let alignment_test_responses: any[] = props.alignment_test_responses
</script>

<Layout {...props}>
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="max-w-4xl mx-auto pb-6">
      <div class="w-full py-6 flex flex-col justify-center">
        <p class="text-3xl text-center text-bold w-full">Alignment Tests</p>
      </div>

      <ul
        class="divide-y divide-gray-100 max-w-4xl mx-auto bg-gray-50 rounded-md"
      >
        {#each alignment_test_responses as response (response.id)}
          <li class="py-6 px-4">
            <a
              href="/plans/{plan.id}/alignment_test/{response.id}"
              class="flex justify-between items-center w-full hover:bg-gray-100 p-2"
            >
              <div class="font-bold">
                {#if response.alignment_test.test_type === "pre"}
                  Pre-Alignment Test
                {:else if response.alignment_test.test_type === "post"}
                  Post-Alignment Test
                {/if}
              </div>
              <div class="text-gray-500 text-sm">
                {formatDate(response.alignment_test.started_at)}
              </div>
              <div>
                {#if response.status === "not_started" || response.status == "invited"}
                  <p
                    class="rounded-md whitespace-nowrap px-3 py-1 text-sm font-medium ring-1 ring-inset text-gray-500 bg-gray-200 ring-gray-400/20"
                  >
                    {response.status_title}
                  </p>
                {:else if response.status === "in_progress"}
                  <p
                    class="rounded-md whitespace-nowrap px-3 py-1 text-sm font-medium ring-1 ring-inset text-green-700 bg-green-50 ring-green-600/20"
                  >
                    {response.status_title}
                  </p>
                {:else if response.status === "complete"}
                  <p
                    class="rounded-md whitespace-nowrap px-3 py-1 text-sm font-medium ring-1 ring-inset text-blue-700 bg-blue-50 ring-blue-600/20"
                  >
                    {response.status_title}
                  </p>
                {/if}
              </div>
              <ChevronsRight class="w-16 h-16 text-gray-400" />
            </a>
          </li>
        {/each}
      </ul>
    </div>
  </div>
</Layout>
